import { useTheme } from '@chakra-ui/react';
import { FC } from 'react';
import { StarIconDefaultVariantProps } from '../types';

const StarIconDefaultVariant: FC<StarIconDefaultVariantProps> = ({
  color,
  width = 12,
  height = 11,
  margin = 0,
  padding = 0,
  cursor = 'default',
  handleClick,
  direction = 'up',
  dataTestId = 'star-icon',
  opacity,
  // Extra Properties
  variant,
  backgroundColor,
  backgroundOpacity = '1',
  borderOpacity = '1'
}) => {
  const theme = useTheme();

  const directionRotation = {
    up: '0deg',
    right: '90deg',
    down: '180deg',
    left: '270deg'
  };

  return (
    <svg
      width={width}
      height={height}
      style={{ margin, padding, cursor, rotate: directionRotation[direction] }}
      viewBox='0 0 12 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}
      data-direction={direction}
      onClick={handleClick}
      data-variant={variant}
    >
      <g data-testid='g-path' opacity={opacity}>
        <path
          d='M5.7366 1.06036C5.84434 0.841004 6.15566 0.841004 6.2634 1.06036L7.65818 3.89992C7.70097 3.98704 7.78369 4.04742 7.87935 4.06139L10.9982 4.51674C11.2391 4.55191 11.3353 4.84939 11.161 5.02013L8.90415 7.23044C8.83494 7.29825 8.80335 7.39593 8.81969 7.49168L9.35245 10.6127C9.3936 10.8538 9.14175 11.0376 8.92626 10.9238L6.13668 9.45025C6.05113 9.40504 5.9489 9.40504 5.86333 9.45025L3.07374 10.9238C2.85825 11.0376 2.6064 10.8538 2.64755 10.6127L3.18031 7.49168C3.19665 7.39593 3.16506 7.29825 3.09585 7.23044L0.839026 5.02013C0.664688 4.84939 0.760891 4.55191 1.00182 4.51674L4.12065 4.06139C4.21631 4.04742 4.29903 3.98704 4.34182 3.89992L5.7366 1.06036Z'
          opacity={backgroundOpacity}
          fill={backgroundColor || theme.colors.gold}
          data-testid='path-with-color'
          stroke={color}
          strokeOpacity={borderOpacity}
        />
      </g>
    </svg>
  );
};

export default StarIconDefaultVariant;
